<template>
  <b-col col cols="12" md="5" class="mx-auto">
    <b-row class="name">
      <h2>{{ name }}</h2>
    </b-row>
    <b-row class="contact-info">
      <i class="fa fa-map-marker" aria-hidden="true"></i>
      {{ address }}
    </b-row>
    <b-row class="contact-info">
      <i class="fa fa-phone"></i>
      {{ phone }}
    </b-row>
    <b-row class="contact-info">
      <i class="fa fa-envelope" aria-hidden="true"></i>
      {{ mail }}
    </b-row>
    <b-row class="contact-info">
      <i class="fa fa-wheelchair" aria-hidden="true"></i>
      {{ pmr }}
    </b-row>
    <b-row class="contact-info">
      <i class="fas fa-map-marked-alt"></i>
      {{ directions }}
    </b-row>
  </b-col>
</template>

<style scoped>
h2 {
  font-size: 1.5rem;
}

.contact-info {
  background-position: left;
}

.contact-info i {
  padding-right: 10px;
}

.name {
  height: 60px;
  margin-top: 50px;
}
</style>

<script>
export default {
  props: ["name", "address", "phone", "mail", "pmr", "directions"]
};
</script>
